import React from "react";

function Loading({ message = "Chargement..." }) {
    return (
        <div style={styles.overlay} className="dark:bg-gray-700 bg-gray-100 dark:text-gray-100 text-gray-700">
            <div style={styles.spinner}></div>
            <p style={styles.message}>{message}</p>
        </div>
    );
}

const styles = {
    overlay: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        fontFamily: "Arial, sans-serif",
    },
    spinner: {
        width: "60px",
        height: "60px",
        border: "6px solid #f3f3f3",
        borderTop: "6px solid #3498db",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        marginBottom: "1rem",
    },
    message: {
        fontSize: "1.2rem",
        fontWeight: "bold",
    },
};

// Animation CSS pour le spinner
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`, styleSheet.cssRules.length);

export default Loading;
